import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import { IMiscSlice } from './types';

const initialState: IMiscSlice = {
  isDbooProfileUpdated: false,
  isWatchlistProfileUpdated: false,
  isDataCollectionModalClosed: false,
  isDataCollectionBannerClosed: false,
};

const miscSlice = createAppSlice({
  name: 'misc',
  initialState,
  reducers: {
    setIsDbooProfileUpdated(state, action: PayloadAction<boolean>) {
      state.isDbooProfileUpdated = action.payload;
    },
    setIsWatchlistProfileUpdated(state, action: PayloadAction<boolean>) {
      state.isWatchlistProfileUpdated = action.payload;
    },
    setIsDataCollectionModalClosed(state, action: PayloadAction<boolean>) {
      state.isDataCollectionModalClosed = action.payload;
    },
    setDataCollectionBannerClosed(state, action: PayloadAction<boolean>) {
      state.isDataCollectionBannerClosed = action.payload;
    },
  },
});

export const {
  setIsDbooProfileUpdated,
  setIsWatchlistProfileUpdated,
  setIsDataCollectionModalClosed,
  setDataCollectionBannerClosed,
} = miscSlice.actions;
export default miscSlice.reducer;
